import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    status: z.enum(["validated", "refused"]),
  }),
  response: z.object({
    success: z.boolean(),
  }),
};
